module.exports = __webpack_public_path__ + "img/stars-rafiki.c5b7b17d.svg";